{
  "#DESIGN_SYSTEM_CATALOG": {
    "TITLE": "Design System"
  }
}
